import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Navbar from "../../Components/Navbar";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { useLocation, useParams } from "react-router-dom";
import TableSetting from "../../Components/Setting/TableSetting";
import { toast } from "react-toastify";
import EditSetting from "../../Components/Setting/EditSetting";
import ViewDetailSetting from "../../Components/Setting/ViewDetailSetting";

const Setting = () => {
  const user = useSelector((state) => state.UserReducer.user);
   const { id } = useParams();
  const location = useLocation();
  const [selectedData, setSelectedData] = useState("");
  const [filterValue, setFilterValue] = useState("");
  // const [filter, setFilter] = useState("phone");
  const [editSetting, setEditSetting] = useState(false);
  const [viewDetail, setViewDetail] = useState(false);


  const [option ,setOption] = useState("phone");
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(1, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );
  const { t, i18n } = useTranslation();


  const fetchFunction = async () => {
    const body = new FormData();
    body.append("clientId", id);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("filterType", option);
    body.append("filterValue", filterValue);
    return await axios.post(`${Config.apiUrl}/getsettings`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const {
    isLoading: isLoading,
    mutate: getSettingMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {});

    useEffect(() => {
      const handler = setTimeout(() => {
        getSettingMutate();
      }, 500);
  
      return () => {
        clearTimeout(handler);
      };
    }, [filterValue, startDate, endDate]);


    //-----Edit Setting--------------

    const EditSettingFunction=async(values)=>{
    const body = new FormData();
    // body.append("id",values.id);
    body.append("clientId", id);
    body.append("propId", selectedData.propId);
    body.append("onlinePayment",selectedData.onlinePayment);
    body.append("whatsApp",values.whatsApp);
    body.append("rentReminder",values.rentReminder);
    body.append("markPaidNotification",values.markPaidNotification);
    body.append("onboardWelcome",values.onboardWelcome);
    body.append("ios",values.ios);
    body.append("android", values.android);
    body.append("footer",values.footer);
    body.append("whatsappOnboardingTemplate", values.whatsappOnboardingTemplate);

    return await axios.post(`${Config.apiUrl}/editsettingpref`, body,{
      headers:{
        authorization:"Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };
  const onEditSettingSuccess = (data)=>{
    if (data?.data?.status == "OK"){
    //   toString.success(data?.data?.msg || "Success");
      toast.success(data?.data?.msg || "Success");
      getSettingMutate();
    }
    else{
      toast.error(data?.data?.msg || "An Error Occurred");
    }
    setSelectedData("");
    setEditSetting(false);
  };
  const onEditSettingError=(data)=>{
    setSelectedData("");
    setEditSetting(false);
    toast.error(data?.response?.data?.msg || "An Error Occurred");
  };
  const { isLoading: editSettingLoading, mutate: editSettingMutate} = useMutation(
    EditSettingFunction,{
      onSuccess: onEditSettingSuccess,
      onError: onEditSettingError,
    }
  );
  
  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>
                {t("Setting")}
                <span>{location?.state?.name}</span>
              </Title>
              <Underline />
            </div>
          </div>
          {editSetting && (
            <EditSetting
               editSettingMutate={editSettingMutate}
               editSettingLoading={editSettingLoading}
               setEditSetting={setEditSetting}
               data={data?.data}
               selectedData={selectedData}
            />
          )}

          {viewDetail && (
            <ViewDetailSetting
              setViewDetail={setViewDetail}
              selectedData={selectedData}
              setSelectedData={setSelectedData}
            />
          )}

          {!error && !isLoading && data && (
            <TableWrapper>
              <TableSetting
                // ApiData={error ? [] : data?.data?.data}
                ApiData={error ? []:
                Array.isArray(data?.data?.data)
                    ? data.data.data
                    : data?.data?.data
                    ? [data.data.data]   // wrap object into array
                    : []
                }
                setSelectedData={setSelectedData}
                setEditSetting={setEditSetting}
                selectedData={selectedData}
                setViewDetail={setViewDetail}
                userType={user.userType}
              />
              {(error || data?.data?.msg == "No data found") && !isLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
          {(isLoading || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const TableWrapper = tw.h1`my-10 border  bg-white rounded-md`;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;
export default Setting;


//data                // React Query result
// data.data           // Axios response body
// data.data.data      // Backend "data" field  Question mark means if this exist then ok if not then undefine